import { render, staticRenderFns } from "./ActivixRoundButton.vue?vue&type=template&id=7ca4ff0b&"
import script from "./ActivixRoundButton.vue?vue&type=script&lang=js&"
export * from "./ActivixRoundButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports